import { createFileRoute } from "@tanstack/react-router";
import { ConfirmWaitlist } from "./-confirm/ConfirmWaitlist";

/** The link in the waitlist confirmation email: `/waitlist/confirm?token=…`. */
export const Route = createFileRoute("/waitlist/confirm")({
  validateSearch: (s: Record<string, unknown>): { token?: string } => (typeof s.token === "string" && s.token ? { token: s.token } : {}),
  staticData: { title: "Confirm your place" },
  component: ConfirmWaitlist,
});
